import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ScrollView, FlatList, View, Text, ActivityIndicator } from 'react-native';

import { debounce } from "lodash";
import { store } from '../../store/store';
import InfiniteScroll from 'react-infinite-scroll-component';

import { listStoreDeals } from '../../utils/services/inventory/LoadMoreDeal';
import { getDealDataForCart } from '../../utils/services/inventory/DealsUtils';
import { isObjectEmpty, isObjectNotEmpty } from '../../utils/services/CommonUtils';
import { ScreenPushBackData } from '../../utils/services/subject-behaviour/CommonRxjsService';
import { GetProductCategories, GetProductSubCategories } from '../../utils/services/inventory/FilterProductCategories';
import { getCartItemFroRedux, mergeDealListWithCartData, upsertCartItem } from '../../utils/services/oms/OMSCartUtils';

import { CommonBackIcon } from '../../utils/widgets/Common-Widget';
import { CartIconView } from '../../utils/widgets/CommonWidget/CartIconView';
import { NoCategoryFilterDealView, NoSearchedDealView } from '../../utils/widgets/deals/NoDealView';
import { ProductCategoriesFilterView } from '../../utils/widgets/Inventory/ProductCategoryFilterView';

import { ScreenPushBackCode } from '../../utils/constants/SubjectBehaviousConstant';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from '../../TextStyle';

import DealView from '../../utils/widgets/deals/DealView';
import TextInputSearchView from '../../utils/widgets/CommonWidget/CommonTextInputSearchView';

const SearchDeals = (props) => {

    let scrollViewRef: any = useRef();

    const reduxState = store.getState()

    const isUserLoggedIn = reduxState.isUserLogin

    const pharmacyProductCategoryList = reduxState.pharmacyAllData['productCategories']

    const [productCategoryList, setProductCategoryList] = useState([])
    const [selectedProductCategory, setSelectedProductCategory] = useState(props.route?.params?.category ?? null)

    const [selectedSubCategory, setSelectedSubCategory] = useState(null)
    const [productSubCategoryList, setProductSubCategoryList] = useState([])

    const [pageNumber, setPageNumber] = useState(0)
    const [cursorAdvancementCounter, setCounter] = useState(0)

    const [hasMoreDeals, setHasMoreDeal] = useState(true)

    const [searchWord, setSearchWord] = useState('')

    const [dealsList, setDealsList] = useState(null)
    const [searchDealsList, setSearchedDealList] = useState(null)

    const [manualDeal, setManualDeal] = useState(null)

    const [cartItems, setCartItems] = useState([])

    const [loading, setLoading] = useState(false)

    function loadDealsList(category, subCategory) {
        setLoading(true)
        let params = getCategoryFilter(category, subCategory)
        listStoreDeals(isUserLoggedIn, params).then(
            (newDealData: any) => {
                let newDeal = newDealData.deals
                if (newDeal.length) {
                    let _newDeal = mergeDealListWithCartData({ deals: newDeal }).dealsList
                    setPageNumber(1)
                    setCounter(newDealData.counter)
                    setDealsList(_newDeal)
                } else setDealsList([])
                setLoading(false)
            }
        )
    }

    function getCategoryList() {
        let categories = GetProductCategories(pharmacyProductCategoryList, {})
        setProductCategoryList(categories)
    }

    function getSubCategoryList(selectedCategory) {
        let subCategories = GetProductSubCategories(pharmacyProductCategoryList, { selectedCategory: selectedCategory })
        setProductSubCategoryList(subCategories)
    }

    const updateCartData = () => {
        let cartItems = getCartItemFroRedux()
        setCartItems(cartItems)
    }

    const cartDataSubscription = useCallback(
        debounce(() => updateCartData(), AppTheme.upsertCartItemDebounce), [])

    useEffect(() => {
        // getCategoryList()
        getSubCategoryList(selectedProductCategory)
        loadDealsList(selectedProductCategory, selectedSubCategory)
        ScreenPushBackData.getPushBackData().subscribe((data: any) => {
            if (data['pushBackCode'] == ScreenPushBackCode.updateProductCategory) {
                let productCategory = data['pushBackData']
                setHasMoreDeal(true)
                if (isObjectNotEmpty(productCategory)) {
                    // clear previous list
                    setDealsList(null)
                    // pull product list
                    loadDealsList(productCategory, null)

                    setSelectedProductCategory(productCategory)
                    setSelectedSubCategory(null)
                    // get sub categories to show filter in view.
                    getSubCategoryList(productCategory)
                    scrollViewRef?.current?.scrollTopMax
                    // scrollViewRef?.current?.scrollIntoView({ behavior: "smooth" })
                    if (selectedProductCategory && productCategory?.cid == selectedProductCategory?.cid) {
                        // do nothing
                    } else { }
                } else {
                    // clear previous list
                    setDealsList(null)
                    // pull product list
                    loadDealsList(null, null)
                    setSelectedProductCategory(null)
                }
                ScreenPushBackData.clearPushBackData()
            }
        })
    }, [])

    useEffect(() => {
        cartDataSubscription();
        store.subscribe(() => { cartDataSubscription() })
    }, [])

    const updateCartItem = (isAdd, deal, quantity = 1) => {
        if (deal.ma) {
            if (!deal.quantity) deal.quantity = 0
            if (isAdd) deal.quantity += 1
            else deal.quantity -= 1
            setManualDeal(deal)
        }
        upsertCartItem(isAdd, getDealDataForCart(deal), quantity, {})
    }

    function searchFilter(_searchWord, _selectedProductCategory, _selectedSubCategory) {
        if (!loading && _searchWord && _searchWord.length > 2) {
            setPageNumber(0)
            setDealsList(null)
            setManualDeal(null)
            setLoading(true)
            let params = getCategoryFilter(_selectedProductCategory, _selectedSubCategory)
            params['searchWord'] = _searchWord
            listStoreDeals(isUserLoggedIn, params).then(
                (searchDealData: any) => {
                    let searchDeal = searchDealData.deals
                    if (searchDeal.length) {
                        let _searchDeal = mergeDealListWithCartData({ deals: searchDeal }).dealsList
                        if (searchDeal.length == 1 && searchDeal[0]?.ma) {
                            setSearchedDealList([])
                            setManualDeal(_searchDeal[0])
                        } else setSearchedDealList(_searchDeal)
                    } else setSearchedDealList(null)
                    setLoading(false)
                }
            )
        }
    }

    const searchDealsDebounce = useCallback(debounce(searchFilter, AppTheme.searchDebounce), [])

    const onChangeText = (text) => {
        setSearchWord(text);
        if (text) searchDealsDebounce(text, selectedProductCategory, selectedSubCategory)
        else {
            loadDealsList(selectedProductCategory, selectedSubCategory)
            setSearchedDealList(null)
        }

    }

    function handleLoadMore(_selectedProductCategory, _selectedSubCategory) {
        if (!loading && hasMoreDeals) {
            let params = { pageNumber: pageNumber, cursorAdvancementCounter: cursorAdvancementCounter }
            params = { ...params, ...getCategoryFilter(_selectedProductCategory, _selectedSubCategory) }
            listStoreDeals(isUserLoggedIn, params).then(
                (newDealData: any) => {
                    let newDeal = newDealData.deals
                    if (newDeal.length) {
                        newDeal = mergeDealListWithCartData({ deals: newDeal }).dealsList
                        setPageNumber(pageNumber + 1)
                        setCounter(newDealData.counter)
                        setDealsList(dealsList.concat(newDeal))
                    } else setHasMoreDeal(false)
                    setLoading(false)
                }
            )
        }
    }

    function cartNavigation() {
        if (global.navigateFrom == NavigateFrom.cart_component_for_search_medicine) {
            global.navigateFrom = ''
            props?.navigation?.navigate(ScreenRoute.cart)
        } else props?.navigation?.navigate(ScreenRoute.review_oms_order)
    }

    function getCategoryFilter(category, subCategory) {
        let filter = {}
        if (category) {
            if (subCategory && subCategory.cid)
                filter = { categoryId: subCategory.cid }
            else filter = { categoryId: category.cid }
        }
        return filter
    }

    function updateSelectedCategory({ category, subCategory = null }) {
        if (isObjectEmpty(category)) return
        if (selectedProductCategory && selectedProductCategory.cid == category.cid) {
            if (isObjectEmpty(subCategory)) return
            setSearchWord('')
            setSearchedDealList(null)
            if (productSubCategoryList && productSubCategoryList.length) {
                setHasMoreDeal(true)
                setDealsList(null)
                if (selectedSubCategory && selectedSubCategory.cid == subCategory.cid) {
                    setSelectedSubCategory(null)
                    loadDealsList(selectedProductCategory, null)
                } else {
                    setSelectedSubCategory(subCategory)
                    loadDealsList(selectedProductCategory, subCategory)
                }
            }
        } else {
            setHasMoreDeal(true)
            setSearchWord('')
            setDealsList(null)
            setSearchedDealList(null)
            setSelectedProductCategory(category)
            loadDealsList(category, null)
        }
    }

    return (<View style={[AppStyles.bg, AppStyles.appHeight]}>

        <View style={[AppStyles.header, AppStyles.pr16, { paddingVertical: 6 }]}>
            <CommonBackIcon navigation={props?.navigation} />
            <TextInputSearchView value={searchWord}
                onChangeText={onChangeText}
                width={AppTheme.appWidth - 100}
                title={'Search for Hair Oil'}
                isLoading={loading} />
            <CartIconView action={cartNavigation} />
        </View>

        <ScrollView style={{ marginTop: AppTheme.headerHeight }} showsHorizontalScrollIndicator={false}>

            <View ref={scrollViewRef} ></View>

            {selectedProductCategory ? productSubCategoryList && productSubCategoryList.length ?
                <ProductCategoriesFilterView action={updateSelectedCategory} category={selectedProductCategory}
                    subCategory={selectedSubCategory} productSubCategoryList={productSubCategoryList} /> :
                <View style={[AppStyles.bg, AppStyles.p16]}>
                    <Text style={[TextStyle.text16, { maxWidth: AppTheme.appWidth - 32 }]}>
                        Products from  <Text style={TextStyle.text16b}>"{selectedProductCategory.name}"</Text></Text>
                </View> : null}

            {searchDealsList && searchWord ? isObjectNotEmpty(manualDeal) ?
                <NoSearchedDealView category={selectedProductCategory} manualDeal={manualDeal}
                    searchWord={searchWord} updateCartDealItem={updateCartItem} /> :
                <FlatList data={searchDealsList}
                    showsVerticalScrollIndicator={false}
                    keyExtractor={(item, index) => "Search Deal: deal_view_" + item.dealId + index}
                    renderItem={({ item, index }) => DealView({
                        deal: { ...item, index: index },
                        navigation: props.navigation,
                        updateCartDealItem: updateCartItem
                    })} snapToAlignment="start" /> :
                dealsList ? dealsList.length ? <InfiniteScroll
                    // style={{ overflow: "inherit" }}
                    dataLength={dealsList.length}
                    hasMore={hasMoreDeals} scrollThreshold={0.9}
                    height={AppTheme.appHeight - AppTheme.headerHeight}
                    // has to show scroll bar else infinite scrolling not working.
                    next={() => handleLoadMore(selectedProductCategory, selectedSubCategory)}
                    loader={<ActivityIndicator color="black" style={{ margin: 16 }} />}
                    endMessage={<p style={TextStyle.alignCenter}><b>Yay! You have seen it all</b></p>}
                // refreshFunction={() => { console.log('### refreshng') }}
                // pullDownToRefresh
                // pullDownToRefreshThreshold={50}
                // pullDownToRefreshContent={
                //     <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
                // }
                // releaseToRefreshContent={
                //     <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
                // }
                >{dealsList.map((_deal, index) => (
                    <View style={{}} key={props?.from + "deal_view_" + _deal.dealId + "_" + index}>
                        {DealView({
                            cartItems: cartItems, dealsList: dealsList,
                            deal: { ..._deal, index: index }, from: "search dea view",
                            navigation: props.navigation, updateCartDealItem: updateCartItem
                        })}</View>
                ))}</InfiniteScroll> : <NoCategoryFilterDealView category={selectedProductCategory} /> : <View />

            }
        </ScrollView>
    </View>)
}

export default SearchDeals
